export default __webpack_public_path__ + "static/media/l-2.d43295d7.jpg";